import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null
  },
  setup(__props: any) {

const props = __props as {
	label: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("h4", null, _toDisplayString(props.label), 1)
  ]))
}
}

})